'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '& .buttonFieldRow': {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flex: 1
  },
  '& .buttonFieldIcon': {
    width: '20px'
  },
  '& .buttonFieldRow .buttonFieldTitle': {
    marginLeft: '10px'
  },
  '& .buttonCircle': {
    fontSize: '24px',
    position: 'relative',
    top: '-2px',
    left: '3px'
  },
  '& .buttonCheck': {
    position: 'relative',
    fontSize: '12px',
    left: '4px',
    bottom: '33px'
  },
  '&': {
    padding: '8px',
    lineHeight: '27px'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref, theme) {
  var value = _ref.value,
      disabled = _ref.disabled;

  var style = (0, _extends3.default)({
    '& .buttonFieldIcon': {
      color: value ? theme.colors.success : theme.colors.primary
    },
    '&:active': {
      color: 'inherit',
      backgroundColor: 'inherit'
    }
  }, (0, _objectResolvePath2.default)(theme, 'CheckedButton.css') || {});

  if (disabled) {
    style['& .buttonFieldIcon'].color = theme.colors.disabled;
    style['&:active'].color = theme.colors.disabled;
  }

  return style;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/CheckedButton/CheckedButton.style.js
// module id = 424
// module chunks = 0